import React from "react";
import Menu from "../Components/Header/Menu";

function Blog() {
  return (
    <>
      <Menu />
    </>
  );
}

export default Blog;
